import { MAX_FILE_SIZE_BYTES } from 'src/enviroment/constants/constants'

export const isWithinSizeLimit = (file: File): boolean => file.size <= MAX_FILE_SIZE_BYTES
